<pr-panel prLoader [loading]="loading">
  <pr-panel-header title="Historique de votre allocation"></pr-panel-header>
  <pr-panel-body clazz="phn">
    <!-- Date Filters -->
    <div class="date-filters">
      <div class="date-filter-group">
        <label for="minDate" class="date-filter-label">Date de début</label>
        <input
          type="date"
          id="minDate"
          class="date-filter-input"
          [(ngModel)]="filterMinDate"
          (change)="applyDateFilter()"
        />
      </div>
      <div class="date-filter-group">
        <label for="maxDate" class="date-filter-label">Date de fin</label>
        <input
          type="date"
          id="maxDate"
          class="date-filter-input"
          [(ngModel)]="filterMaxDate"
          (change)="applyDateFilter()"
        />
      </div>
      @if (filterMinDate || filterMaxDate) {
        <button class="date-filter-reset-btn" (click)="resetDateFilter()">
          <pr-icon name="close" [width]="16"></pr-icon>
          Réinitialiser
        </button>
      }
    </div>

    @if (historyData && historyData.length > 0) {
      <div class="history-table">
        <!-- Header -->
        <div class="history-table-header">
          <div class="history-row">
            <div class="history-cell history-cell-expand"></div>
            <div class="history-cell history-cell-date">Date</div>
            <div class="history-cell history-cell-value">Valorisation</div>
            <div class="history-cell history-cell-investment">
              Somme investie
            </div>
          </div>
        </div>
        <!-- Body -->
        <div class="history-table-body">
          @for (row of historyData; track row) {
            <!-- Main row -->
            <div
              class="history-row history-row-clickable"
              [class.history-row-expanded]="row.expanded"
              (click)="toggleRow(row)"
            >
              <div class="history-cell history-cell-expand">
                @if (row.allocations?.length) {
                  <pr-icon
                    [name]="
                      row.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                    "
                    [width]="24"
                    class="expand-icon"
                  ></pr-icon>
                }
              </div>
              <div class="history-cell history-cell-date">
                {{ row.date | date: 'dd/MM/yyyy' }}
              </div>
              <div class="history-cell history-cell-value">
                {{ row.valeurActuelle | currency: 'EUR' : 'symbol' : '.2-2' }}
              </div>
              <div class="history-cell history-cell-investment">
                {{
                  row.sommeInvestissement | currency: 'EUR' : 'symbol' : '.2-2'
                }}
              </div>
            </div>

            @if (row.expanded && row.allocations?.length) {
              <div class="history-row-detail">
                <div class="allocations-container">
                  <h4 class="allocations-title">Détails de l'allocation</h4>
                  <div class="allocations-table">
                    <!-- Allocations Header -->
                    <div class="allocation-row allocation-header">
                      <div class="allocation-cell allocation-cell-name">
                        Nom du support
                      </div>
                      <div class="allocation-cell allocation-cell-date">
                        Date
                      </div>
                      <div class="allocation-cell allocation-cell-amount">
                        Montant
                      </div>
                      <div class="allocation-cell allocation-cell-parts">
                        Nb. de parts
                      </div>
                      <div class="allocation-cell allocation-cell-pmv">
                        Plus ou moins-value
                      </div>
                    </div>
                    <!-- Allocations Body -->
                    @for (allocation of row.allocations; track allocation) {
                      <div class="allocation-row">
                        <div class="allocation-cell allocation-cell-name">
                          {{ allocation.name }}
                        </div>
                        <div class="allocation-cell allocation-cell-date">
                          {{ allocation.date | date: 'dd/MM/yyyy' }}
                        </div>
                        <div class="allocation-cell allocation-cell-amount">
                          {{
                            allocation.montant
                              | currency: 'EUR' : 'symbol' : '.2-2'
                          }}
                        </div>
                        <div class="allocation-cell allocation-cell-parts">
                          {{ allocation.parts | number: '1.2-5' }}
                        </div>
                        <div
                          class="allocation-cell allocation-cell-pmv"
                          [ngClass]="allocation.plusOuMoinsValueClass"
                        >
                          @if (
                            allocation.plusOuMoinsValueClass === 'pmv-positive'
                          ) {
                            <span class="pmv-icon">▲</span>
                          }
                          @if (
                            allocation.plusOuMoinsValueClass === 'pmv-negative'
                          ) {
                            <span class="pmv-icon">▼</span>
                          }
                          <span class="pmv-value">{{
                            allocation.plusOuMoinsValueFormatted
                          }}</span>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          }
        </div>
      </div>
    }

    <!-- Empty state -->
    @if (!loading && historyData.length === 0) {
      <div class="history-table-empty">
        <p>Aucun historique disponible</p>
      </div>
    }

    <!-- Pagination -->
    @if (totalPages > 1) {
      <div class="history-pagination">
        <button
          class="pagination-btn"
          [disabled]="!hasPrevious"
          (click)="onPrevious()"
        >
          <pr-icon name="chevron_left" [width]="20"></pr-icon>
        </button>
        @for (page of pageNumbers; track page) {
          <button
            class="pagination-btn pagination-page"
            [class.active]="page === currentPage"
            (click)="onPageChange(page)"
          >
            {{ page + 1 }}
          </button>
        }
        <button class="pagination-btn" [disabled]="!hasNext" (click)="onNext()">
          <pr-icon name="chevron_right" [width]="20"></pr-icon>
        </button>
        <span class="pagination-info">
          Page {{ currentPage + 1 }} sur {{ totalPages }} ({{ totalElements }}
          éléments)
        </span>
      </div>
    }
  </pr-panel-body>
</pr-panel>
